import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { DropdownButton, Dropdown } from "react-bootstrap";
import api from "services/api";

// components
import ProfileDetails from "elements/dashboardElements/ProfileDetails";
import Cashier from "elements/dashboardElements/Cashier";
import AccountActvity from "elements/dashboardElements/AccountActvity";
import TransactionHistory from "elements/dashboardElements/TransactionHistory";
import GamingHistory from "elements/dashboardElements/GamingHistory";
import FreeSpins from "elements/dashboardElements/FreeSpins";
import Notifications from "elements/dashboardElements/Notifications";
import Messages from "elements/dashboardElements/Messages";
import AccessControl from "elements/dashboardElements/AccessControl";
import FavoriteGames from "elements/dashboardElements/FavoriteGames";
import ReferAndEarn from "elements/dashboardElements/ReferAndEarn";
import CommunicationPreferences from "elements/dashboardElements/CommunicationPreferences";
// import NftHolders from "elements/dashboardElements/NftHolders";
import Verify from "elements/dashboardElements/Verify";
import Withdraw from "elements/dashboardElements/Withdraw";
import PwaDashboardSectionSheet from "components/PwaDashboardSectionSheet";
import PwaDashboardHero from "components/PwaDashboardHero";
import { Tabs, Tab } from "react-bootstrap";
import Translator, { __ } from "services/Translator";
export default function UserDashboard(props) {
  const params = useParams();
  const tab = params.tab;
  const [activeTab, setActiveTab] = useState("account-details");
  const [activeTabName, setActiveTabName] = useState("Account Details");
  const history = useHistory();

  const closeDetails = () => {
    history.push("/games/all");
  };

  const [travelingToRight, setTravelingToRight] = useState(false);

  useEffect(() => {
    setActiveTab(tab);

    // Handle tab parameter mapping
    if (tab === "favorite-games") {
      setKey("FavoriteGames");
    } else if (tab === "account-details") {
      setKey("account");
    } else if (tab === "verify") {
      setKey("verify");
    } else if (tab === "transaction-history") {
      setKey("TransactionHistory");
    } else if (tab === "account-activity") {
      setKey("AccountActivity");
    } else if (tab === "gaming-history") {
      setKey("GamingHistory");
    } else if (tab === "responsible-gaming") {
      setKey("ResponsibleGaming");
    } else if (tab === "preferences") {
      setKey("Preferences");
    }

    setTravelingToRight(true);
    setTimeout(function () {
      setTravelingToRight(false);
    }, 500);

    // alert(tab)
  }, [tab]);

  //Verify id checking

  const [level2submitted, setLevel2submitted] = useState(false);
  const [level2Verification, setLevel2Verification] = useState(false);

  const [level3submitted, setLevel3submitted] = useState(false);
  const [level3Verification, setLevel3Verification] = useState(false);

  const [level4submitted, setLevel4submitted] = useState(false);
  const [level4Verification, setLevel4Verification] = useState(false);

  const getIdUploads = async () => {
    var response = await api.get("/id-uploads");
    console.log("id-uploadsid-uploads", response);
    if (response.status === 200 && response.data) {
      if (response.data.poif && response.data.poib) {
        if (
          response.data.poif.approved == "approved" &&
          response.data.poib.approved == "approved"
        ) {
          setLevel2Verification(true);
        } else if (
          response.data.poif.approved == "submitted" &&
          response.data.poib.approved == "submitted"
        ) {
          setLevel2submitted(true);
        }
      }

      if (response.data.poa) {
        if (response.data.poa.approved == "approved") {
          setLevel3Verification(true);
        } else if (response.data.poa.approved == "submitted") {
          setLevel3submitted(true);
        }
      }
      if (response.data.sof) {
        if (response.data.sof.approved == "approved") {
          setLevel4Verification(true);
        } else if (response.data.sof.approved == "submitted") {
          setLevel4submitted(true);
        }
      }
    }
  };

  useEffect(() => {
    if (props.isAuthenticated) {
      getIdUploads();
    }
  }, []);

  const [showMainNotification, setShowMainNotification] = useState(false);
  useEffect(() => {
    if (
      props.freeSpinCount > 0 ||
      props.notifictionCount > 0 ||
      props.messageCount ||
      !level2submitted ||
      !level3submitted
    ) {
      setShowMainNotification(true);
    } else {
      setShowMainNotification(false);
    }
  }, [props]);

  //Custom action for Tabs
  const [key, setKey] = useState("account");

  const handleSelect = (k) => {
    console.log(`Selected tab: ${k}`);
    // Add your custom action here
    customAction(k);
    setKey(k);
  };

  const customAction = (selectedKey) => {
    switch (selectedKey) {
      case "account":
        console.log("Home tab selected");
        // Add any custom logic for the Home tab here
        break;
      case "verify":
        console.log("Profile tab selected");
        // Add any custom logic for the Profile tab here
        break;
      case "TransactionHistory":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;

      case "AccountActivity":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "GamingHistory":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "ResponsibleGaming":
        console.log("Contact tab selected");
        // Add any custom logic for the Contact tab here
        break;
      case "FavoriteGames":
        console.log("Favorite Games tab selected");
        // Add any custom logic for the Favorite Games tab here
        break;
      default:
        break;
    }
  };

  //Edit Account Action
  const [editAccountAction, setEditAccountAction] = useState(false);

  const handleDataFromProfileDetails = (childData) => {
    setEditAccountAction(childData);
    if (childData == true) {
      setKey("verify");
    }
  };

  // PWA bottom sheet for switching dashboard sections (mobile only).
  const [sectionSheetOpen, setSectionSheetOpen] = useState(false);

  // Simple inline SVG icons (filled, currentColor) — same convention as the
  // sidebar and the PWA bottom nav. Slugs match the route params handled above.
  const dashboardNavItems = [
    {
      slug: "account-details",
      label: __("Account"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-5.33 0-8 2.67-8 5v1h16v-1c0-2.33-2.67-5-8-5z" />
        </svg>
      ),
    },
    {
      slug: "verify",
      label: __("Verify"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 14-4-4 1.41-1.41L11 13.17l4.59-4.58L17 10l-6 6z" />
        </svg>
      ),
    },
    {
      slug: "transaction-history",
      label: __("Transactions"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
        </svg>
      ),
    },
    {
      slug: "account-activity",
      label: __("Activity"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6a7 7 0 1 1 2.05 4.95l-1.42 1.42A9 9 0 1 0 13 3zm-1 5v5l4.25 2.52.75-1.23-3.5-2.04V8z" />
        </svg>
      ),
    },
    {
      slug: "gaming-history",
      label: __("Play history"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-2 14.5v-9l6 4.5-6 4.5z" />
        </svg>
      ),
    },
    {
      slug: "responsible-gaming",
      label: __("Safer play"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M12 2 4 5v6c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V5l-8-3z" />
        </svg>
      ),
    },
    {
      slug: "favorite-games",
      label: __("Favorites"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
      ),
    },
    {
      slug: "preferences",
      label: __("Preferences"),
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M19.14 12.94a7.5 7.5 0 0 0 .05-.94 7.5 7.5 0 0 0-.05-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.61-.22l-2.39.96a7.3 7.3 0 0 0-1.62-.94l-.36-2.54A.5.5 0 0 0 13.9 2h-3.8a.5.5 0 0 0-.5.42l-.36 2.54c-.58.24-1.12.55-1.62.94l-2.39-.96a.5.5 0 0 0-.61.22L2.7 8.48a.5.5 0 0 0 .12.64l2.03 1.58a7.5 7.5 0 0 0 0 1.88l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.13.23.4.32.61.22l2.39-.96c.5.39 1.04.7 1.62.94l.36 2.54a.5.5 0 0 0 .5.42h3.8a.5.5 0 0 0 .5-.42l.36-2.54a7.3 7.3 0 0 0 1.62-.94l2.39.96c.21.1.48.01.61-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7z" />
        </svg>
      ),
    },
  ];

  const activeSlug = tab || "account-details";
  const activeSectionLabel =
    dashboardNavItems.find((item) => item.slug === activeSlug)?.label ?? __("Account");

  const handleSectionSelect = (slug) => {
    setSectionSheetOpen(false);
    history.push("/dashboard/" + slug);
  };

  return (
    <div className="container">
      <div
        className={
          "userDashboard " + (travelingToRight ? "travelingToRight" : "")
        }
      >
        {[
          // URL slugs (activeTab holds the route param, i.e. the kebab-case slug).
          // These all map to a <Tab> via the key mapping in the [tab] effect above.
          "account-details",
          "verify",
          "transaction-history",
          "account-activity",
          "gaming-history",
          "responsible-gaming",
          "favorite-games",
          "preferences",
        ].includes(activeTab) && (
            <>
              <div className="account_tabs">
                {/* Mobile-only hero strip: instant name + balance so the area
                    under the PWA header is never empty. Hero -> section bar -> tabs. */}
                <PwaDashboardHero />
                {/* Mobile-only section bar: current section + kebab to open the sheet. */}
                <div className="pwa-dashboard__section-bar">
                  <h2 className="pwa-dashboard__section-title">{activeSectionLabel}</h2>
                  <button
                    type="button"
                    className="pwa-dashboard__section-menu-btn"
                    onClick={() => setSectionSheetOpen(true)}
                    aria-label={__("Switch section")}
                  >
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
                      <circle cx="12" cy="5" r="2" />
                      <circle cx="12" cy="12" r="2" />
                      <circle cx="12" cy="19" r="2" />
                    </svg>
                  </button>
                </div>
                <PwaDashboardSectionSheet
                  open={sectionSheetOpen}
                  onClose={() => setSectionSheetOpen(false)}
                  items={dashboardNavItems}
                  activeSlug={activeSlug}
                  onSelect={handleSectionSelect}
                  verifyNeedsUpload={!level2submitted || !level3submitted}
                />
                {/* mountOnEnter/unmountOnExit: only the active tab is mounted so
                    AccessControl (Responsible Gaming) and CommunicationPreferences
                    (Preferences) can't hold divergent stale copies of the same
                    account flags (player_accepts_bonuses / player_accepts_subscr).
                    Entering a tab remounts its component, which re-fetches the
                    authoritative server state and keeps the two consistent. */}
                <Tabs
                  defaultActiveKey="account"
                  id="uncontrolled-tab-example"
                  className="mb-3 userDashboard-tabs"
                  activeKey={key}
                  onSelect={handleSelect}
                  mountOnEnter
                  unmountOnExit
                >
                  <Tab eventKey="account" title={__("Account")}>
                    <ProfileDetails
                      sendDataToParent={handleDataFromProfileDetails}
                      {...props}
                    />
                  </Tab>
                  <Tab
                    eventKey="verify"
                    title={
                      ((!level2submitted || !level3submitted) && (
                        <>
                          {__("Verify")}{" "}
                          <div className="notification_round"></div>
                        </>
                      )) ||
                      ((level2submitted || level3submitted) && (
                        <>
                          {__("Verify")}{" "}
                          <div className="notification_round orenge"></div>
                        </>
                      ))
                    }
                  >
                    {(!level2submitted || !level3submitted) && (
                      <div className="notification_round"></div>
                    )}

                    {level2submitted && level3submitted && (
                      <div className="notification_round orenge"></div>
                    )}
                    <Verify {...props} />
                  </Tab>
                  <Tab
                    eventKey="TransactionHistory"
                    title={__("Transaction History")}
                  >
                    <TransactionHistory {...props} />
                  </Tab>
                  <Tab eventKey="AccountActivity" title={__("Account Activity")}>
                    <AccountActvity {...props} />
                  </Tab>
                  <Tab eventKey="GamingHistory" title={__("Gaming History")}>
                    <GamingHistory {...props} />
                  </Tab>

                  <Tab eventKey="ResponsibleGaming" title={__("Responsible Gaming")}>
                    <AccessControl {...props} />
                  </Tab>
                  <Tab eventKey="FavoriteGames" title={__("Favorite Games")}>
                    <FavoriteGames {...props} />
                  </Tab>
                  <Tab eventKey="Preferences" title={__("Preferences")}>
                    <CommunicationPreferences {...props} />
                  </Tab>
                </Tabs>
              </div>
            </>
          )}

        {activeTab === "cashier" && <Cashier {...props} />}

        {activeTab === "free-spins" && <FreeSpins {...props} />}
        {activeTab === "notifications" && <Notifications {...props} />}
        {activeTab === "messages" && <Messages {...props} />}

        {activeTab === "my-games" && <FavoriteGames {...props} />}
        {activeTab === "refer-and-earn" && <ReferAndEarn {...props} />}
        {/* {activeTab === "nft-holders" && <NftHolders {...props} />} */}

        {activeTab === "withdraw" && <Withdraw {...props} />}
      </div>
    </div>
  );
}
